export default __webpack_public_path__ + "static/media/mobile_glowboo.1b30f294.png";